// extracted by mini-css-extract-plugin
export var green = "section-module--green--c3556";
export var inner = "section-module--inner--cce85";
export var lightestGreen = "section-module--lightestGreen--3fccd";
export var nearBlack = "section-module--nearBlack--2c2a9";
export var white = "section-module--white--33d44";
export var wrapper = "section-module--wrapper--69a53";